import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Services from '../components/Services';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Discount from '../components/Discount';

const Home = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Hero />
      <Stats />
      <Services />
      <Discount />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Home;
